// AuthGuard Service
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

@Injectable()
export class RewardsOffersListPageGuard 
{
    /**
     * Class constructor
     * @param router
     * @param auth
     */
    constructor
        (
            private router: Router,
            private auth: AuthProvider
        )
    {
    }

    /**
     * CanActivate method implementation, returning true if the page can
     * be accessed or a URL tree if a redirection has to be done.
     * Will return true only if the user country and categoryId
     * query parameters
     * @param next
     * @param state
     */
    async canActivate(route: ActivatedRouteSnapshot)
    {
        let userCountry = route.queryParams.userCountry;
        let categoryId = route.queryParams.categoryId;

        if (userCountry && categoryId !== "null")
        {
            return true;

        }
        else
        {
            let sessionToken = (await this.auth.getUserIdentity()).sessionToken;
            return this.router.parseUrl('/home/' + sessionToken);
        }
    }
}